import React from 'react';
import { Button, Grid } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { makeStyles } from '@material-ui/styles';
import TieredLineItemRateRule from './TieredLineItemRateRule';
import { generateTestId } from '../../../../../../utils';
import { tieredRateFormDefault } from './line-item-config-form-utils';

// The form for adding a 'tiered' line item rate with more complex conditional rules
function TieredLineItemRate({ name, disabledOnEdit = false }) {
    const { control, getValues, setValue } = useFormContext();

    const useStyles = makeStyles((theme) => ({
        container: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(2),
            backgroundColor: theme.palette.background.default,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: theme.palette.divider,
            borderRadius: theme.shape.borderRadius,
        },
        buttonContainer: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
    }));
    const classes = useStyles();

    const { fields, append, remove, insert, swap } = useFieldArray({
        control,
        name: `${name}.rules`,
    });

    const addRule = () => {
        append(tieredRateFormDefault);
    };

    // Controller fields registered with `shouldUnregister` (e.g. the numeric FormInputs
    // in BasicLineItemRate / TieredRuleCondition) do not reliably re-sync their displayed
    // value after a useFieldArray swap, which causes swapped rules to show the wrong
    // rate/amount. Re-emitting the swapped values via setValue forces those Controllers
    // to re-read the correct values.
    const swapRules = (fromIndex, toIndex) => {
        if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) {
            return;
        }
        swap(fromIndex, toIndex);
        setValue(`${name}.rules`, getValues(`${name}.rules`));
    };

    return (
        <div>
            {fields.map((field, index) => (
                <Grid key={field.id} className={classes.container}>
                    <TieredLineItemRateRule name={`${name}.rules.${index}`} index={index} ruleCount={fields.length} duplicateRule={insert} swapRule={swapRules} removeRule={() => remove(index)} disabledOnEdit={disabledOnEdit} />
                </Grid>
            ))}
            <Grid container className={classes.buttonContainer}>
                <Button variant="outlined" onClick={addRule} data-testid={generateTestId(name, 'add-rule-btn')} disabled={disabledOnEdit}>
                    Add Rule
                </Button>
            </Grid>
        </div>
    );
}

export default TieredLineItemRate;
